import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTerminal = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.5996 4C20.4393 4 20.8598 3.99981 21.1807 4.16309C21.4629 4.3069 21.6931 4.53709 21.8369 4.81934C22.0002 5.14015 22 5.56068 22 6.40039V17.5996C22 18.4393 22.0002 18.8598 21.8369 19.1807C21.6931 19.4629 21.4629 19.6931 21.1807 19.8369C20.8598 20.0002 20.4393 20 19.5996 20H4.40039C3.56068 20 3.14015 20.0002 2.81934 19.8369C2.53709 19.6931 2.3069 19.4629 2.16309 19.1807C1.99981 18.8598 2 18.4393 2 17.5996V6.40039C2 5.56068 1.99981 5.14015 2.16309 4.81934C2.3069 4.53709 2.53709 4.3069 2.81934 4.16309C3.14015 3.99981 3.56068 4 4.40039 4H19.5996ZM7.41895 7.81445C6.83052 7.35716 5.98009 7.39882 5.43945 7.93945L5.31445 8.08105C4.85717 8.66948 4.89882 9.51991 5.43945 10.0605L7.37793 12L5.43945 13.9395L5.31445 14.0811C4.85717 14.6695 4.89882 15.5199 5.43945 16.0605C6.02524 16.6463 6.97476 16.6463 7.56055 16.0605L10.5605 13.0605L10.6855 12.9189C11.1428 12.3305 11.1012 11.4801 10.5605 10.9395L7.56055 7.93945L7.41895 7.81445Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .4,
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.41935 7.81456C6.83091 7.35702 5.98007 7.39861 5.43934 7.93934L5.31456 8.08065C4.85702 8.66909 4.89861 9.51993 5.43934 10.0607L7.3775 12L5.43934 13.9393L5.31456 14.0807C4.85702 14.6691 4.89861 15.5199 5.43934 16.0607C6.02513 16.6464 6.97487 16.6464 7.56066 16.0607L10.5607 13.0607L10.6854 12.9193C11.143 12.3309 11.1014 11.4801 10.5607 10.9393L7.56066 7.93934L7.41935 7.81456Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTerminal);
export { ForwardRef as ReactComponent };
